import { useState, useEffect, useCallback } from 'react';

import { useService, JOKI } from '../../JOKI';

export function useGlobalStore(key, initialValue = undefined) {
    
    const trigger = useService('GlobalStoreService', false)[1];
    const [data, setData] = useState(initialValue);

    // useEffect(() => {
    //     if (fullData !== null && fullData[key] !== data) {
    //         const value = fullData[key];

    //         if (value === undefined && initialValue !== undefined) {
    //             // update(initialValue); // Why is this called if it only triggers when the GlobalStore changes...?
    //             setData(initialValue);
    //         } else {
    //             setData(fullData[key]);
    //         }
    //         console.log("UPDATE data from/to :", data, "/", value, fullData);
    //     }
    // }, [fullData, data]);

    // Listen for updates in GlobalStoreService
    useEffect(() => {
        return JOKI.on({
            from: 'GlobalStoreService',
            key: 'valueChanged',
            fn: event => {
                if (event.body.key === key && event.body.value !== data) {
                    setData(event.body.value);
                }
            },
        });
    }, [data, key]);

    useEffect(() => {
        return JOKI.on({
            from: 'GlobalStoreService',
            key: 'valueDeleted',
            fn: event => {
                if (event.body.key === key) {
                    setData(initialValue);
                }
            },
        });
    }, [key, initialValue]);

    const update = useCallback(
        newValue => {
            trigger({
                key: 'set',
                body: {
                    key,
                    value: newValue,
                },
            });
        },
        // eslint-disable-next-line
        [key]
    );

    // Get the initial data
    useEffect(() => {
        async function getInitialValue(dkey) {
            const res = await JOKI.ask({
                to: 'GlobalStoreService',
                key: 'get',
                body: {
                    key: dkey,
                },
            });
            const value = res.GlobalStoreService;
            if (value !== initialValue && value !== undefined) {
                setData(value);
            } else {
                // Set update
                if (value === undefined) {
                    update(initialValue);
                }
            }
        }

        getInitialValue(key);
    }, [initialValue, key, update]);

    // If the initialvalue is changed and no value in full data is set yet, update it.
    // useEffect(() => {
    //     if(fullData !== null && fullData[key] === undefined) {
    //         update(initialValue);
    //     }
    // }, [initialValue, fullData])

    function deleteValue() {
        // if (initialValue !== undefined) {
        //     update(initialValue);
        //     return;
        // }

        trigger({
            key: 'delete',
            body: {
                key,
            },
        });
    }

    return [data, update, deleteValue];
}
